module.exports = __webpack_public_path__ + "static/img/Bachelor_010853.5913fc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010853.jpg
// module id = 261
// module chunks = 0